<template>
  <ripristinable-dialog v-model="isActive" @confirm="onConfirm" :title="$t('tecnici.messaggi.eliminato')">

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.nome') }}: </span>
      <b>{{ tecnico.nome }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.cognome') }}: </span>
      <b>{{ tecnico.cognome }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('tecnici.label.username') }}</span>
      <b>{{ tecnico.username }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.telefono') }}: </span>
      <b>{{ $utils.formatPhone(tecnico.telefono) }}</b>
    </v-flex>

  </ripristinable-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import RipristinableDialog from '@/components/base/RipristinableDialog'

export default {
    name: 'TecnicoDeletedDialog',
    mixins: [Toggleable],
    components: { RipristinableDialog },
    data: () => ({
        tecnico: {}
    }),
    methods: {
        show (tecnico) {
            this.tecnico = tecnico
            this.isActive = true
        },
        onConfirm () {
            let vue = this
            this.$confirmDialog.show(
                this.tecnico.username,
                this.$t('tecnici.messaggi.conferma_ripristino'),
                function (username) {
                    this.$api.tecnici.restore(username)
                        .then(() => {
                            vue.$snackbar.show(this.$t('tecnici.messaggi.ripristinato'), 'success')
                            vue.$emit('success')
                            vue.isActive = false
                        }).catch(e => {
                            if (e.response.status === 304) {
                                vue.$snackbar.show(this.$t('tecnici.errori.errore_ripristino'), 'error')
                            } else {
                                vue.$snackbar.showServerError(e)
                            }
                        })
                })
        }
    }
}
</script>
